var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1500_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1500_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H0V13H13V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1500_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3793 2.19922e-07C10.8104 -0.000177757 11.2348 0.107671 11.615 0.313991C11.9952 0.52031 12.3194 0.818729 12.559 1.18281C12.7985 1.54688 12.946 1.96537 12.9883 2.4012C13.0306 2.83702 12.9664 3.27672 12.8015 3.68133C12.6366 4.08594 12.376 4.44298 12.0428 4.72079C11.7096 4.99861 11.3141 5.18863 10.8914 5.27402C10.4686 5.35941 10.0316 5.33753 9.61919 5.21032C9.20675 5.0831 8.83156 4.85449 8.52687 4.54473C8.50359 4.52108 8.48138 4.49744 8.45916 4.47271L5.16472 5.8701C5.24032 6.18473 5.25932 6.51065 5.2208 6.83215L8.56919 8.41764C9.03235 7.97086 9.64073 7.71222 10.2791 7.69072C10.9174 7.66923 11.5413 7.88638 12.0325 8.30103C12.5238 8.71568 12.8483 9.29902 12.9446 9.94051C13.0408 10.582 12.9021 11.2371 12.5548 11.7816C12.2074 12.3262 11.6756 12.7224 11.06 12.8951C10.4443 13.0678 9.78772 13.0051 9.21456 12.7189C8.6414 12.4326 8.1915 11.9427 7.9501 11.3419C7.70871 10.7411 7.69259 10.0713 7.9048 9.45924L4.79656 7.98231C4.49632 8.43874 4.06455 8.78972 3.56038 8.98718C3.05621 9.18464 2.50429 9.21893 1.9802 9.08535C1.45611 8.95176 0.985475 8.65684 0.632741 8.24096C0.280008 7.82508 0.0624229 7.30859 0.0097824 6.7622C-0.0428582 6.21582 0.0720194 5.66626 0.338684 5.18878C0.605349 4.7113 1.01076 4.32924 1.49941 4.09493C1.98805 3.86062 2.53604 3.78551 3.06833 3.87989C3.60061 3.97426 4.09117 4.23351 4.47283 4.62213C4.51938 4.66942 4.56487 4.71887 4.60719 4.76939L7.85931 3.39135C7.74836 2.99524 7.72936 2.57837 7.80381 2.17354C7.87825 1.7687 8.04412 1.38693 8.28836 1.05824C8.53259 0.729558 8.84854 0.462921 9.21136 0.279296C9.57419 0.0956718 9.97398 6.72568e-05 10.3793 2.19922e-07Z",
    fill: "#B99750"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1500_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconShare);
export default __webpack_public_path__ + "static/media/share-icon-share.cecbef4fbde5d66c7f381c5aa63e0350.svg";
export { ForwardRef as ReactComponent };